import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo lo recibo?',
    a: 'Por descarga inmediata en tu email después del pago.'
  }, {
    q: '¿Es en video?',
    a: 'No. Solo PDF escrito en español, listo para imprimir.'
  }, {
    q: '¿Incluye materiales?',
    a: 'No. Los materiales iniciales cuestan aprox. $50-$100. El módulo 2 te dice exactamente qué comprar y dónde en EE.UU.'
  }, {
    q: '¿Necesito experiencia?',
    a: 'No. Empieza desde cero absoluto.'
  }, {
    q: '¿Hay reembolsos?',
    a: 'Por ser digital, no aceptamos devoluciones. Si hay problema con la descarga, lo resolvemos en 24 horas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-alt py-14" data-id="element-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center mb-8" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text" data-id="element-15">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-16">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-brand-line/20 overflow-hidden" data-id="element-17">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex justify-between items-center p-6 text-left focus:outline-none" data-id="element-18">
                <span className="font-semibold text-brand-text text-lg" data-id="element-19">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-20">
                  <ChevronDown className="w-5 h-5 text-brand-subtext" data-id="element-21" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-22">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-23">
                    <div className="px-6 pb-6 text-brand-subtext" data-id="element-24">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}